{
    "actions": {
        "page": {
            "add_beneficiary": "Ajouter un bénéficiaire"
        },
        "beneficiary": {
            "associate_contract": "Associer un contrat",
            "update_label": "Renommer",
            "delete": "Supprimer",
            "contracts_count_one": "contrat",
            "contracts_count_other": "contrats",
            "no_legal_info": "Aucune information légale",
            "no_beneficiaries": "Aucun bénéficiaire trouvé",
            "dissaociate_contract": {
                "success": "Contract dissocié avec succès",
                "error": "Une erreur est survenue en essayant de dissocier le contrat."
            },
            "update_color": {
                "success": "Couleur mise à jour avec succès",
                "error": "Échec de la mise à jour de la couleur"
            }
        },
        "contract": {
            "legal_name": "Nom légal",
            "merchant_name": "Ligne plaque"
        }
    },
    "modal": {
        "create": {
            "title": "Ajouter un bénéficiaire",
            "label": "Nom du bénéficiaire",
            "placeholder": "Entrez le nom du bénéficiaire",
            "success": "Bénéficiaire ajouté avec succès",
            "error": "Échec de l'ajout du bénéficiaire"
        },
        "delete": {
            "title": "Supprimer le bénéficiaire",
            "text": "Êtes-vous sûr de vouloir supprimer le bénéficiaire suivant ?",
            "success": "Bénéficiaire supprimé avec succès",
            "error": "Échec de la suppression du bénéficiaire"
        },
        "associate_contract": {
            "title": "Ajout de contrat pour {{benefeciary}}",
            "success": "Les contracts sont associés avec succès.",
            "error": "Impossible de modifier les contrats du bénéficiaire."
        },
        "update_label": {
            "title": "Modifier le nom du bénéficiaire",
            "label": "Nom du bénéficiaire",
            "success": "Nom du bénéficiaire modifié avec succès",
            "error": "Échec de la modification du nom du bénéficiaire"
        }
    }
}